export default "__VITE_ASSET__BlvjqDRk__"